<table mat-table [dataSource]="announcements">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>ID</th>
    <td mat-cell *matCellDef="let p">
      {{p.id}}
    </td>
  </ng-container>
  <ng-container matColumnDef="prefix">
    <th mat-header-cell *matHeaderCellDef>Prefix</th>
    <td mat-cell *matCellDef="let p">
      {{p.prefix == null ? 'CHAT_AD' : p.prefix}}
    </td>
  </ng-container>
  <ng-container matColumnDef="message">
    <th mat-header-cell *matHeaderCellDef>Message</th>
    <td mat-cell *matCellDef="let p">
      {{p.message}}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns" routerLink="/announces/{{row.id}}"></tr>
</table>
